const elementSelector = [
    "a[href]",
    "select:not([disabled])",
    "input:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled]"
];
function nodelistToArray(nodes) {
    const arr = [];
    for (let i = nodes.length; i--;) {
        arr.unshift(nodes.item(i));
    }
    return arr;
}
const tabEnabledSelectors = ["[tabIndex='0']"].concat(elementSelector);
const allTabIndexEnabledSelectors = ["[tabIndex]"].concat(elementSelector);
export function getFocusableElements(el, onlyTabReachable = true) {
    try {
        if (!el) {
            return null;
        }
        if (onlyTabReachable) {
            return nodelistToArray(el.querySelectorAll(tabEnabledSelectors.join(",")));
        }
        else {
            return nodelistToArray(el.querySelectorAll(allTabIndexEnabledSelectors.join(",")));
        }
    }
    catch (e) {
        return;
    }
}
export function focusFirstElement(el) {
    const elements = getFocusableElements(el);
    if (elements && elements.length > 0) {
        elements[0].focus();
    }
    else {
        el.focus();
    }
}
export function focusFirstElementInList(el) {
    const listElement = el.querySelectorAll(".list .item[tabIndex='0'], .list .item[tabIndex='-1']").item(0);
    if (listElement) {
        listElement.focus();
    }
}
//# sourceMappingURL=focusUtils.js.map